<template>
    <div>
        <Banner :banners="banners" :videos="videos" show-video></Banner>
        <div class="info-wrapper green">
            <div class="card info-card mb-4 news">
                <div class="card-header">
                    川柳大小事-最新消息
                </div>
                <div class="card-body">
                    <Loader
                        :show="newsLoading"
                        :height="211"
                        class="mb-2"
                    ></Loader>
                    <ul class="list-group mb-3" v-show="!newsLoading">
                        <li
                            class="list-group-item info-item"
                            v-for="news in lastNews"
                            :key="news.id"
                        >
                            <a
                                :href="news.Url"
                                class="info-link"
                                target="_blank"
                            >
                                <div class="home-list-card">
                                    <div class="card-body">
                                        <span
                                            class="text text-date"
                                            :title="
                                                dateConvert(
                                                    news.startDate,
                                                    'YYYY-MM-DD',
                                                )
                                            "
                                            v-text="
                                                dateConvert(
                                                    news.startDate,
                                                    'YYYY-MM-DD',
                                                )
                                            "
                                        >
                                            2022-02-01 ~ 2022-02-28
                                        </span>
                                        <div class="text-wrapper">
                                            <div
                                                class="title"
                                                :title="news.name"
                                                v-text="news.name"
                                            >
                                                2022臺中水水DER特刊(200dpi，含月曆)
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </li>
                    </ul>
                </div>
                <div class="card-footer">
                    <a
                        href=""
                        class="d-block"
                        @click.prevent="goView('/everything/news')"
                    >
                        看更多消息
                        <img src="@/assets/ic_arrow.svg" alt="" />
                    </a>
                </div>
            </div>

            <div class="card info-card mb-4 activity">
                <div class="card-header">
                    川柳大小事-活動行事曆
                </div>
                <div class="card-body">
                    <Loader
                        :show="dataLoading"
                        :height="170"
                        class="mb-3"
                    ></Loader>
                    <ul class="list-group mb-3" v-show="!dataLoading">
                        <li
                            class="list-group-item info-item"
                            v-for="event in eventList"
                            :key="event.id"
                        >
                            <a
                                href="#"
                                class="info-link"
                                @click.prevent="
                                    goDetail('everything/event', event.id)
                                "
                            >
                                <div class="home-list-card">
                                    <vue-load-image>
                                        <img
                                            slot="image"
                                            :src="
                                                `${apiPhotoUrl}/ori/${event.photoId}`
                                            "
                                            :alt="event.name"
                                        />
                                        <img
                                            slot="preloader"
                                            src="@/assets/image-loader.gif" class="w-100"
                                        />
                                        <img
                                            slot="error"
                                            class="border d-block"
                                            src=""
                                            alt="not found"
                                        />
                                    </vue-load-image>
                                    <div class="card-body">
                                        <span
                                            class="text text-date"
                                            :title="
                                                dateConvert(
                                                    event.startDate,
                                                    'YYYY-MM-DD',
                                                ) +
                                                    '~' +
                                                    dateConvert(
                                                        event.endDate,
                                                        'YYYY-MM-DD',
                                                    )
                                            "
                                            v-text="
                                                dateConvert(
                                                    event.startDate,
                                                    'YYYY-MM-DD',
                                                ) +
                                                    '~' +
                                                    dateConvert(
                                                        event.endDate,
                                                        'YYYY-MM-DD',
                                                    )
                                            "
                                        >
                                            2022-02-01 ~ 2022-02-28
                                        </span>
                                        <div class="text-wrapper">
                                            <div
                                                class="title"
                                                :title="event.name"
                                                v-text="event.name"
                                            >
                                                2022臺中水水DER特刊(200dpi，含月曆)
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </li>
                    </ul>
                </div>
                <div class="card-footer">
                    <a
                        href=""
                        class="d-block"
                        @click.prevent="goView('/everything/event')"
                    >
                        看更多活動
                        <img src="@/assets/ic_arrow.svg" alt="" />
                    </a>
                </div>
            </div>

            <div class="card info-card mb-4 river">
                <div class="card-header">
                    川流城事-七大河川介紹
                </div>
                <div class="card-body my-3">
                    <Loader :show="dataLoading" :height="272"></Loader>
                    <div class="row" v-show="!dataLoading">
                        <div
                            class="col-6 mb-3"
                            v-for="river in riverList"
                            :key="river.id"
                        >
                            <a
                                href=""
                                class="d-block"
                                @click.prevent="goView('/river/' + river.id)"
                            >
                                <div class="home-river-wrapper">
                                    <vue-load-image>
                                        <img
                                            slot="image"
                                            :src="
                                                `${apiPhotoUrl}/ori/${river.photoId}`
                                            "
                                            :alt="river.name"
                                        />
                                        <img
                                            slot="preloader"
                                            src="@/assets/image-loader.gif" class="w-100"
                                        />
                                        <img
                                            slot="error"
                                            class="border d-block"
                                            src=""
                                            alt="not found"
                                        />
                                    </vue-load-image>

                                    <div class="text" v-text="river.name">
                                        綠川
                                    </div>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <a
                        href=""
                        class="d-block"
                        @click.prevent="goView('/river')"
                    >
                        瀏覽更多河川資訊
                        <img src="@/assets/ic_arrow.svg" alt="" />
                    </a>
                </div>
            </div>

            <div class="card info-card mb-4 guide">
                <div class="card-header">
                    走讀河川-多元數位導覽
                </div>
                <div class="card-body my-3">
                    <div class="row mb-3">
                        <div class="col-12">
                            <a
                                href=""
                                class="d-block"
                                @click.prevent="goView('/guide/customize')"
                            >
                                <div class="home-guide-wrapper">
                                    <img
                                        src="@/assets/home_img_part_self.png"
                                        style="width:132px;"
                                        alt="自訂遊玩時間"
                                    />
                                    <div class="text">自訂遊玩時間</div>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="row form-row">
                        <div class="col-4">
                            <a
                                href=""
                                class="d-block"
                                @click.prevent="goView('/guide/tour/family')"
                            >
                                <div class="home-guide-wrapper">
                                    <img
                                        src="@/assets/home_img_part_family.png"
                                        style="width:50px;"
                                        alt="親子"
                                    />
                                    <div class="text">親子</div>
                                </div>
                            </a>
                        </div>
                        <div class="col-4">
                            <a
                                href=""
                                class="d-block"
                                @click.prevent="goView('/guide/tour/couple')"
                            >
                                <div class="home-guide-wrapper">
                                    <img
                                        src="@/assets/home_img_part_lover.png"
                                        style="width:50px;"
                                        alt="情侶"
                                    />
                                    <div class="text">情侶</div>
                                </div>
                            </a>
                        </div>
                        <div class="col-4">
                            <a
                                href=""
                                class="d-block"
                                @click.prevent="goView('/guide/tour/culture')"
                            >
                                <div class="home-guide-wrapper">
                                    <img
                                        src="@/assets/home_img_part_culture.png"
                                        style="width:50px;"
                                        alt="人文"
                                    />
                                    <div class="text">人文</div>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <a
                        href=""
                        class="d-block"
                        @click.prevent="goView('/guide')"
                    >
                        瀏覽更多導覽方式
                        <img src="@/assets/ic_arrow.svg" alt="" />
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import Banner from '@/components/shared/Banner';

import coreMixin from '@/js/mixin/coreMixin';
import Loader from '@/components/Loader';
import { apiBanners } from '@/plugin/api';

export default {
    name: 'Home',
    data() {
        return {
            banners: [],

            videos: [],
        };
    },
    mounted() {
        this.getBanners();
    },
    computed: {
        ...mapState('dataList', [
            'eventList',
            'newsList',
            'riverList',
            'newsLoading',
            'dataLoading',
        ]),
        lastNews() {
            return this.newsList.slice(0, 3);
        },
    },
    methods: {
        goView(link) {
            this.$router.push(link);
        },
        goDetail(view, id) {
            this.$router.push(`/${view}/${id}`);
        },
        getBanners() {
            this.banners = [];
            this.videos = [];
            apiBanners().then((res) => {
                if (res.data) {
                    res.data.forEach((item) => {
                        if (item.bannerType === 0) {
                            this.banners.push(item);
                        } else if (item.bannerType === 1) {
                            this.videos.push(item);
                        }
                    });
                }
            });
        },
    },
    components: {
        Banner,
        Loader,
    },
    mixins: [coreMixin],
};
</script>

<style></style>
